export default "__VITE_ASSET__Qvo8MJtIYQeyzbgc$mEmNA__"